import { PaymentDetailsResponseType } from '../GetPaymentDetails';

export type RateType = {
  identifier: string;
  totalPremium: string;
  monthlyPremium: string;
  pdfDownloadURL?: string;
  underwritingPassed: true;
  paymentDetails: PaymentDetailsResponseType['paymentDetails'];
};

export type RateUwFailType = {
  identifier: string;
  underwritingPassed: false;
};

export const isRateUwFailType = (
  rate: RateType | RateUwFailType
): rate is RateUwFailType => {
  return rate.underwritingPassed === false;
};

export type RateResponseType =
  | {
      identifier: string;
      totalPremium: string;
      monthlyPremium: string;
      pdfDownloadURL?: string;
      underwritingPassed: true;
      paymentDetails: PaymentDetailsResponseType['paymentDetails'];
    }
  | {
      identifier: string;
      underwritingPassed: false;
    };
